import { captureDesignerScreenshot } from "../../designer-screenshot-actions";
import type { ToolHandlerGroup } from "../types";

export const screenshotTools: ToolHandlerGroup = {
  async: {
    ui_style_capture_screenshot: captureDesignerScreenshot
  }
};
